import React from "react";

import { TD, TH } from "./table";

import { INTERCOM_APP_ID } from "config";
import { useUserProfileProperties } from "hooks/use_user_properties";
import { IntercomConversationType } from "shared/types";
import { formatDateTime } from "utils/date";
import { toTitleCase } from "utils/string";
import { longDisplayName } from "utils/user";

type IntercomConversationTablePropsType = {
  intercomConversations: IntercomConversationType[];
};

type IntercomConversationRowPropsType = {
  intercomConversation: IntercomConversationType;
};

function IntercomConversationRow({ intercomConversation }: IntercomConversationRowPropsType) {
  const conversationId = intercomConversation.intercom_conversation_id;
  const intercomUrl = `https://app.intercom.com/a/apps/${INTERCOM_APP_ID}/conversations/${conversationId}`;
  const userId = String(intercomConversation.user_id);
  const user = useUserProfileProperties(userId);
  return (
    <tr>
      <TD>{formatDateTime(intercomConversation.created_on)}</TD>
      <TD>
        {intercomConversation.closed_on ? formatDateTime(intercomConversation.closed_on) : "N/A"}
      </TD>
      <TD>{toTitleCase(intercomConversation.started_by) || "Unknown"}</TD>
      <TD>{intercomConversation.closed_on ? "Closed" : "Open"}</TD>
      <TD>{longDisplayName(user) || "(not enrolled in class)"}</TD>
      <TD>
        <a href={intercomUrl} target="_blank" rel="noreferrer">
          View on Intercom
        </a>
      </TD>
    </tr>
  );
}

function IntercomConversationTable({ intercomConversations }: IntercomConversationTablePropsType) {
  if (intercomConversations.length === 0) {
    return null;
  }
  return (
    <table className="fds-table table-hover" data-testid="intercom-conversation-table">
      <thead>
        <tr>
          <TH>Started At</TH>
          <TH>Closed At</TH>
          <TH>Started By</TH>
          <TH>Status</TH>
          <TH>User</TH>
          <TH>View on Intercom</TH>
        </tr>
      </thead>
      <tbody>
        {intercomConversations.map((conversation) => {
          return (
            <IntercomConversationRow
              key={conversation.intercom_conversation_id}
              intercomConversation={conversation}
            />
          );
        })}
      </tbody>
    </table>
  );
}

export { IntercomConversationRow, IntercomConversationTable };
